var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":""}},[_c('v-card',{staticClass:"primary lighten-1 white--text",attrs:{"width":"100%","flat":"","tile":""}},[_c('v-card-text',{staticClass:"white--text text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" © "),_c('span',[_vm._v("Plantemos un árbol")]),_c('br'),_vm._v(" Zapopan Jalisco, México ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }